<template>
  <div>
    <b-form-group id="workflow-label" label="Workflow:" label-for="workflow">
      <b-form-select id="workflow" v-model="workflowId" :options="workflowOptions" />
    </b-form-group>
    <b-form-group label="Show Events From:">
      <b-form-radio-group v-model="dateRangeType" :options="dateRangeTypeOptions">
      </b-form-radio-group>
    </b-form-group>
    <div v-if="dateRangeType === 'recent'" class="form-inline">
      <label for="count" class="mr-2">Show the last:</label>
      <b-form-input id="count" type="text" v-model="dateRangeCount" placeholder="Number" class="mr-2" />
      <b-form-select id="periodType" v-model="dateRangePeriodType" :options="dateRangePeriodTypeOptions" />
    </div>
    <div v-if="dateRangeType === 'custom'">
      <b-form-group id="start-date-label" label="Start Date" label-for="start-date">
        <date-picker id="start-date" v-model="dateRangeStartDate" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
      </b-form-group>
      <b-form-group id="end-date-label" label="End Date" label-for="end-date">
        <date-picker id="end-date" v-model="dateRangeEndDate" style="width:100%" lang="en" format="DD/MM/YYYY"></date-picker>
      </b-form-group>
    </div>
<!--     <b-form-group id="team-label" label="Team:" label-for="team">
      <b-form-select id="team" v-model="teamId" :options="teamOptions" class="mb-1" />
      <b-form-radio-group v-model="teamFilterSetting" :options="teamFilterSettingOptions" name="team-filter-setting" stacked></b-form-radio-group>
    </b-form-group> -->
    <b-form-group label="Event Status:" class="mt-1">
      <b-form-radio-group v-model="eventStatus" :options="eventStatusOptions" name="event-status" stacked></b-form-radio-group>
    </b-form-group>
  </div>
</template>


<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'ReportFilters',
  props: ['workflows', 'value'],
  components: { DatePicker },
  data () {
    const valueDateRange = this.value.date_range || {}
    return {
      workflowId: null,
      teamId: null,
      teamFilterSetting: (this.value.team_filter_setting || 'all'),
      eventStatus: (this.value.event_status || 'all'),
      dateRangeType: (['custom', 'all'].includes(valueDateRange.type) ? valueDateRange.type : 'recent'),
      dateRangeCount: (valueDateRange.count || 14),
      dateRangePeriodType: (['custom', 'all'].includes(valueDateRange.type) ? 'weeks' : valueDateRange.type),
      dateRangeStartDate: (valueDateRange.start ? moment(valueDateRange.start) : moment().subtract(1, 'months')),
      dateRangeEndDate: (valueDateRange.end ? moment(valueDateRange.end) : moment()),
      dateRangeTypeOptions: [
        {text: 'Recent Events', value: 'recent'},
        {text: 'Custom period', value: 'custom'},
        {text: 'All Time', value: 'all'}
      ],
      dateRangePeriodTypeOptions: [
        {text: 'Weeks', value: 'weeks'},
        {text: 'Days', value: 'days'}
      ]
    }
  },
  computed: {
    filters () {
      return {
        workflow_id: this.workflowId,
        team_id: this.teamId,
        team_filter_setting: this.teamFilterSetting,
        date_range: this.dateRangeFilter,
        event_status: this.eventStatus
      }
    },
    dateRangeFilter () {
      if (this.dateRangeType === 'custom') {
        return {type: 'custom', start: moment(this.dateRangeStartDate).format(), end: moment(this.dateRangeEndDate).format()}
      } else if (this.dateRangeType === 'all') {
        return {type: 'all'}
      } else {
        return {type: this.dateRangePeriodType, count: this.dateRangeCount}
      }
    },
    workflowOptions () {
      return this.workflows.map((workflow) => { return { text: workflow.name, value: workflow.id } })
    },
    teamOptions () {
      return [
        { text: 'All Teams', value: null }
      ].concat(this.$store.getters.teams.map((team) => { return { text: team.name, value: team.id } }))
    },
    teamFilterSettingOptions () {
      return [
        { text: 'All events involving this team', value: 'all' },
        { text: 'Only events where this team was the originator', value: 'originator' },
        { text: 'Only events where this team was the receiver', value: 'receiver' }
      ]
    },
    eventStatusOptions () {
      return [
        { text: 'All events', value: 'all' },
        { text: 'Only events that have been closed', value: 'closed' }
      ]
    }
  },
  watch: {
    workflows () {
      if (this.workflowId) {
        if (this.workflows.find((wf) => { return wf.id === this.workflowId }) == null) {
          this.workflowId = null
        }
      }
      if (this.workflowId == null && this.workflows.length > 0) {
        this.workflowId = this.workflows[0].id
      }
    },
    workflowId () { this.emitUpdate() },
    teamId () { this.emitUpdate() },
    teamFilterSetting () { this.emitUpdate() },
    eventStatus () { this.emitUpdate() },
    dateRangeType () { this.emitUpdate() },
    dateRangeCount () { this.emitUpdate() },
    dateRangePeriodType () { this.emitUpdate() },
    dateRangeStartDate () { this.emitUpdate() },
    dateRangeEndDate () { this.emitUpdate() }
  },
  methods: {
    emitUpdate () {
      this.$emit('update:filters', this.filters)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportFilters.vue